import React, { useEffect, useRef, useState } from 'react'
import styles from './index.module.scss'

type TCProps = { className?: string; children?: React.ReactNode; zoom?: number }
function TouchContainer(props: TCProps) {
  // 缩放比例 和 偏移量
  const [zoom, setZoom] = useState(props.zoom || 1)
  const [offsetX, setOffsetX] = useState(0)
  const [offsetY, setOffsetY] = useState(0)
  const touchDataRef = useRef({
    startX: 0, // 触摸起始点 X 坐标
    startY: 0, // 触摸起始点 Y 坐标
    startOffsetX: 0, // 元素起始偏移 X
    startOffsetY: 0, // 元素起始偏移 Y
    initialDistance: 0, // 两指缩放的初始距离
    initialZoom: 2, // 初始缩放比例
    midX: 0, // 两指缩放的中点 X 坐标
    midY: 0 // 两指缩放的中点 Y 坐标
  })

  useEffect(() => {
    setZoom(props.zoom || 1)
  }, [props.zoom])

  // useEffect(() => {
  //   const touchContainer = document.getElementById('touch-container')
  //   if (!touchContainer) return

  //   touchContainer.addEventListener('touchmove', handleTouchMove)
  //   touchContainer.addEventListener('touchstart', handleTouchStart)
  //   return () => {
  //     touchContainer.removeEventListener('touchmove', handleTouchMove)
  //     touchContainer.removeEventListener('touchstart', handleTouchStart)
  //   }
  // }, [offsetX, offsetY])

  const handleTouchStart = (e: TouchEvent | React.TouchEvent) => {
    const touch = e.touches[0]
    console.log('touch start', touch.clientX, touch.clientY)
    touchDataRef.current.startX = touch.clientX
    touchDataRef.current.startY = touch.clientY
    touchDataRef.current.startOffsetX = offsetX
    touchDataRef.current.startOffsetY = offsetY
    if (e.touches.length === 2) {
      const t1 = e.touches[0]
      const t2 = e.touches[1]
      // 记录两指缩放的初始数据:距离，当前缩放比例，中点坐标
      const distance = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY)
      touchDataRef.current.initialDistance = distance
      touchDataRef.current.initialZoom = zoom
      // 计算中点坐标
      const midX = (t1.clientX + t2.clientX) / 2
      const midY = (t1.clientY + t2.clientY) / 2
      touchDataRef.current.midX = midX
      touchDataRef.current.midY = midY
    }
  }

  const handleTouchMove = (e: TouchEvent | React.TouchEvent) => {
    console.log('touch move')
    const touch = e.touches[0]
    const dx = touch.clientX - touchDataRef.current.startX
    const dy = touch.clientY - touchDataRef.current.startY
    if (e.touches.length === 1) {
      setOffsetX(prev => {
        const newX = touchDataRef.current.startOffsetX - dx * 0.5
        return newX
      })
      setOffsetY(prev => {
        const newY = touchDataRef.current.startOffsetY - dy * 0.5
        return newY
      })
    }
    if (e.touches.length === 2) {
      const touch2 = e.touches[1]
      // 计算当前两指之间的距离
      const distance = Math.hypot(touch2.clientX - touch.clientX, touch2.clientY - touch.clientY)
      // 根据距离调整缩放比例
      const newZoom = Math.max(0.8, Math.min(10, distance / touchDataRef.current.initialDistance * touchDataRef.current.initialZoom))
      setZoom(newZoom)
      // setOffsetX(prev => {
      //   const deltaMidX = (touch2.clientX + touch.clientX) / 2 - touchDataRef.current.midX
      //   const newX = touchDataRef.current.startOffsetX + deltaMidX - dx * 0.5
      //   return -newX
      // })
      // setOffsetY(prev => {
      //   const deltaMidY = (touch2.clientY + touch.clientY) / 2 - touchDataRef.current.midY
      //   const newY = touchDataRef.current.startOffsetY + deltaMidY - dy * 0.5
      //   return -newY
      // })
    }
  }

  const contRef = useRef<HTMLDivElement>(null)
  return (
    <div
      id='touch-container'
      ref={contRef}
      onTouchMove={handleTouchMove}
      onTouchStart={handleTouchStart}
      className={`${styles.TouchContainer} ${props.className}`}
      style={{ transform: `translate(${-offsetX}px, ${-offsetY}px) scale(${zoom})` }}
    >
      {props.children}
    </div>
  )
}

const MemoTouchContainer = React.memo(TouchContainer)

export default MemoTouchContainer
